module.exports = __webpack_public_path__ + "static/media/YM86_2.b5b5c657.jpg";